import { parseDoc, type Doc } from './docs';

// Carrega todos os .md desta pasta no build (texto cru). Ver docs.ts para o formato.
const files = import.meta.glob('./**/*.md', { query: '?raw', import: 'default', eager: true }) as Record<string, string>;

export const DOCS: Doc[] = Object.entries(files).map(([file, text]) => parseDoc(file, text).doc);

export const DOC_PROBLEMS: string[] = Object.entries(files).flatMap(([file, text]) => parseDoc(file, text).problems);

export * from './docs';
